export default {
    INVALID_DATA: 'Datos de creación no válidos, por favor envía un informe de error.',
    INVALID_ITEM: 'Elemento seleccionado no válido.',
    INVALID_ITEMS: 'No tienes los elementos necesarios para fabricar eso.',
    SELECT_ITEM: 'Por favor selecciona un artículo para crear.',
    FAILED_CRAFT: 'Has fallado en crear el {{failedText}}.'
} as const;
